import api from "../../client";
import { CreateFieldPayload, CreateFieldResponseData } from "../../types/enum";

export const createFieldRequest = async (payload: CreateFieldPayload) => {
  const { data } = await api.post<CreateFieldResponseData>(`/field`, payload);

  return data;
};
